import React, { Component } from "react";
export default class NumberLocation extends Component {
  render() {
    var {
      number_location_score,
      number_location_status_1,
      number_location_status_2,
      number_location_status_3,
      number_location_status_4,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-12">
          <hr />
          <ul style={{ paddingLeft: 20, fontSize: 19 }}>
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Ask the person “Which number corresponds to the position of
                  the dot?’ Progress from left to right and top to bottom to
                  move through the squares
                </li>
                <li style={{ listStyle: "circle" }}>
                  All squares should be attempted.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Scoring:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  One point for each correct answer
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Which number corresponds to the position of the dot?
                </li>
              </ul>
            </li>
          </ul>
          <hr />
          <div className="row">
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                  marginLeft: -6,
                }}
              >
                &nbsp;&nbsp;<b>1) Correct Answer:</b> 6
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="number-location-image"
                  src={require("../../../../../../assets/img/numbr-location/1.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={number_location_status_1 == "0" ? false : true}
                  name="number_location_status_1"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                  marginLeft: -6,
                }}
              >
                &nbsp;&nbsp;<b>2) Correct Answer:</b> 5
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="number-location-image"
                  src={require("../../../../../../assets/img/numbr-location/2.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={number_location_status_2 == "0" ? false : true}
                  name="number_location_status_2"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                  marginLeft: -6,
                }}
              >
                &nbsp;&nbsp;<b>3) Correct Answer:</b> 2
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="number-location-image"
                  src={require("../../../../../../assets/img/numbr-location/3.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={number_location_status_3 == "0" ? false : true}
                  name="number_location_status_3"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                  marginLeft: -6,
                }}
              >
                &nbsp;&nbsp;<b>4) Correct Answer:</b> 3
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="number-location-image"
                  src={require("../../../../../../assets/img/numbr-location/4.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={number_location_status_4 == "0" ? false : true}
                  name="number_location_status_4"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <br />
              <span className="fs-19">Score (0-4) </span>
              <input
                type="number"
                disabled
                name="number_location_score"
                value={number_location_score}
                className="ecas-input-field"
                placeholder="Score"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
